module.exports = __webpack_public_path__ + "static/media/twitter-logo.f8422e4b.svg";